import { defineMessages } from 'react-intl'

export const errorViewMessages = defineMessages({
  title: {
    id: 'components.errorView.title',
    defaultMessage: 'Uh ohh!'
  },
  subtitle: {
    id: 'components.errorView.subtitle',
    defaultMessage: 'It looks like there’s something wrong. Please try again'
  },
  btnText: {
    id: 'components.errorView.btnText',
    defaultMessage: 'Go back Home'
  },
  checkLatest: {
    id: 'components.errorView.checkLatest',
    defaultMessage: 'Checkout our latest'
  },
  projects: {
    id: 'components.errorView.projects',
    defaultMessage: 'Projects'
  },
  news: {
    id: 'components.errorView.news',
    defaultMessage: 'News'
  },
  articles: {
    id: 'components.errorView.articles',
    defaultMessage: 'Articles'
  },
  products: {
    id: 'components.errorView.products',
    defaultMessage: 'Products'
  },
  competitions: {
    id: 'components.errorView.competitions',
    defaultMessage: 'Competitions'
  },
  events: {
    id: 'components.errorView.events',
    defaultMessage: 'Events'
  },
  or: {
    id: 'components.errorView.or',
    defaultMessage: 'or'
  }
})